import { Closeable } from '../interfaces/closeable.interface';
import { Dismissable } from '../interfaces/dismissable.interface';

export class ActiveModal implements Closeable, Dismissable {

    /**
     * The active modal's shared data.
     *
     * @type {}
     */
    private data: { [key: string]: any } = {};

    /**
     * Close the modal and gave an optional result.
     *
     * @param result
     */
    public close(result?: any): void {
    }

    /**
     * Dismiss the modal and give an optional reason.
     *
     * @param reason
     */
    public dismiss(reason?: any): void {
    }

    /**
     * Close the modal and gave an optional result.
     *
     * @param result
     */
    public beforeClose(result?: any): void {
    }

    /**
     * Dismiss the modal and give an optional reason.
     *
     * @param reason
     */
    public beforeDismiss(reason?: any): void {
    }

    /**
     * Set a value in the shared data.
     *
     * @param {string} key
     * @param value
     */
    public set(key: string, value: any): void {
        this.data[key] = value;

        this.data = Object.assign({}, this.data);
    }

    /**
     * Get a value from the shared data.
     *
     * @param {string} key
     * @return {T}
     */
    public get<T>(key: string): T {
        return this.data[key];
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/classes/active-modal.ts